import './NewListLink.scss';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UserStore } from '../store/User';
import { Button, Popover } from '@iba-team/portal-react-components/dist';
import PartyIcon from '../assets/icons/party-popper80.png';


interface NewListLinkProps {
  to: string,
  openInNewTab: boolean,
  onClick?: React.MouseEventHandler<HTMLAnchorElement> | undefined,
}

const NewListLink: React.FunctionComponent<NewListLinkProps> = ({to, openInNewTab, onClick}) => {
  const userStore = UserStore;
  const [hintVisibility, setHintVisibility] = useState(userStore.profile.isNewlistPopupViewed);
  const { t } = useTranslation();

  useEffect(()=> {
    setHintVisibility(userStore.profile.isNewlistPopupViewed);
  },[userStore.profile.isNewlistPopupViewed]);

  return (
    <div className='newlist'>
      <Popover
        className='newlist__popover'
        getPopupContainer={(e) => (e.parentNode as HTMLElement)}
        placement='bottom'
        open={hintVisibility}
        content={
          <>
            <div className='newlist__popover__title'>
              <img className='newlist__popover__title__icon' src={PartyIcon} alt="PartyIcon"/>
              <span className='newlist__popover__title__text'>{t('hints.newList.title')}</span>
            </div>
            <div className='newlist__popover__description'>{t('hints.newList.description')}</div>
            <Button
              theme={{ color: 'theme', variant: 'primary' }}
              onClick={() => {
                userStore.setNewListPopupVisibility(false);
                setHintVisibility(false);
              }}
            >{t('hints.newList.okBtnText')}</Button>
          </>
        }
      >
        <Link
          className='newlist__link' 
          to={to}
          target={openInNewTab ? '_blank' : ''}
          rel={openInNewTab ? 'noopener noreferrer' : ''}
          onClick={onClick}
        >{t('newList') }
        </Link>
      </Popover>
    </div>
  );
};

export default NewListLink;
